import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import UpdateNotification from './components/feature/UpdateNotification';
import VersionInfo from './components/feature/VersionInfo';
import { ErrorBoundary } from './components/base/ErrorBoundary';
import { useState, useEffect } from 'react';
import BalanceNotification from './components/feature/BalanceNotification';

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineWarning, setShowOfflineWarning] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      console.log('✅ Connection restored');
      setIsOnline(true);
      setShowOfflineWarning(false);
    };

    const handleOffline = () => {
      console.log('❌ Connection lost');
      setIsOnline(false);
      setShowOfflineWarning(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <ErrorBoundary>
      {showOfflineWarning && (
        <div className="fixed top-0 left-0 right-0 bg-red-500 text-white py-3 px-4 text-center z-50 shadow-lg">
          <div className="flex items-center justify-center gap-2">
            <i className="ri-wifi-off-line text-xl"></i>
            <span className="font-medium">No internet connection. Please check your network.</span>
          </div>
        </div>
      )}
      {isOnline && (
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <UpdateNotification />
          <VersionInfo />
        </BrowserRouter>
      )}
      {!isOnline && (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-wifi-off-line text-3xl text-red-500"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">No Internet Connection</h2>
            <p className="text-gray-600 mb-6">
              Please check your internet connection and try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-teal-500 hover:bg-teal-600 text-white font-semibold py-3 px-6 rounded-xl transition-colors"
            >
              <i className="ri-refresh-line mr-2"></i>
              Retry Connection
            </button>
          </div>
        </div>
      )}
    </ErrorBoundary>
  );
}

export default App;
